module.exports = __webpack_public_path__ + "img/PorkAustria.79312b7a.png";